import { render } from "./ClientSettingsMenu.vue?vue&type=template&id=1aaf6e06&scoped=true"
import script from "./ClientSettingsMenu.vue?vue&type=script&lang=js"
export * from "./ClientSettingsMenu.vue?vue&type=script&lang=js"

import "./ClientSettingsMenu.vue?vue&type=style&index=0&id=1aaf6e06&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aaf6e06"]])

export default __exports__